import { render } from "./PendingPaymentLiquidations.vue?vue&type=template&id=554b1d86"
import script from "./PendingPaymentLiquidations.vue?vue&type=script&lang=js"
export * from "./PendingPaymentLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__